// extracted by mini-css-extract-plugin
module.exports = {"hero":"HeroBanner_hero__XrZCo","paginationCard":"HeroBanner_paginationCard__oj2M_"};